 <template>
  <div class="footer">
    <div><strong> تمام حقوق و امتیاز سایت متعلق به 
      <a href="https://bitaidea.com">بیتا ایده توانا</a>
       می باشد </strong>&copy; ۱۴۰۵ {{ $appVersion }}</div>
  </div>
</template>
<script>
export default {
    
}
</script>